import React from 'react';
import { Link } from 'react-router-dom';
import './AdminSidebar.css';

const AdminSidebar = ({ isOpen, currentPath }) => {
  const menuItems = [
    {
      title: 'Dashboard',
      icon: 'fas fa-chart-line',
      path: '/admin/dashboard'
    },
    {
      title: 'Demo Requests',
      icon: 'fas fa-calendar-check',
      path: '/admin/demo-requests',
      badge: 'pending'
    },
    {
      title: 'Organizations',
      icon: 'fas fa-building',
      path: '/admin/organizations'
    },
    {
      title: 'Clients',
      icon: 'fas fa-handshake',
      path: '/admin/vendors'
    },
    {
      title: 'Subscription Plans',
      icon: 'fas fa-box',
      path: '/admin/plans'
    },
    {
      title: 'Users',
      icon: 'fas fa-users',
      path: '/admin/users'
    },
    {
      title: 'Chat',
      icon: 'fas fa-comments',
      path: '/admin/chat'
    },
    {
      title: 'Contact-Us',
      icon: 'fas fa-phone',
      path: '/admin/contact'
    },
    {
      title: 'Analytics',
      icon: 'fas fa-chart-bar',
      path: '/admin/analytics'
    },
    {
      title: 'Settings',
      icon: 'fas fa-cog',
      path: '/admin/settings'
    },
    {
      title: 'Currencies',
      icon: 'fa-regular fa-money-bill-1',
      path: '/admin/currencies'
    },
  ];

  return (
    <aside className={`admin-sidebar ${isOpen ? 'open' : 'closed'}`}>
      <div className="admin-sidebar-header">
        <div className="admin-logo">
          <i className="fas fa-shield-alt"></i>
          {isOpen && <span>Admin Portal</span>}
        </div>
      </div>

      <nav className="admin-sidebar-nav">
        {menuItems.map((item, index) => (
          <Link
            key={index}
            to={item.path}
            className={`admin-nav-item ${currentPath === item.path ? 'active' : ''}`}
          >
            <i className={item.icon}></i>
            {isOpen && (
              <>
                <span>{item.title}</span>
                {item.badge && (
                  <span className="badge badge-warning">New</span>
                )}
              </>
            )}
          </Link>
        ))}
      </nav>
    </aside>
  );
};

export default AdminSidebar;

